import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        let user = res.data.user;
        const intended = localStorage.getItem("intended_role");
        localStorage.removeItem("intended_role");
        if (!user.role && (intended === "candidate" || intended === "employer")) {
          try {
            await api.post("/auth/role", { role: intended });
            user = { ...user, role: intended };
          } catch { /* role stays unset; user will be asked on /select-role */ }
        }
        setUser(user);
        const dest =
          user.role === "candidate" ? "/candidate/dashboard"
          : user.role === "employer" ? "/employer/dashboard"
          : (user.role === "admin" || user.role === "super_admin") ? "/admin/dashboard"
          : "/dashboard";
        window.history.replaceState(null, "", dest);
        navigate(dest, { state: { user }, replace: true });
      } catch {
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#D96B27] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-slate-600 font-display">Signing you in…</p>
      </div>
    </div>
  );
}
